import { h } from "preact";

export default function LocationAddress({ location }) {
  return (
    <div class="location-address">
      <h5>{location.title}</h5>
      <p class="address-line">{location.address}</p>
      <p class="">{location.tel}</p>
      <p class="">{location.mail}</p>
    </div>
  );
}
